import React from 'react'

const Clock = () => {
  /* eslint-disable max-len */
  return (
    <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
      <g fillRule="nonzero" fill="none">
        <circle fill="#E2E8F0" cx="10" cy="10" r="10" />
        <path
          d="M11 9.59l3.2 3.2a1 1 0 0 1-1.4 1.42l-3.5-3.5A1 1 0 0 1 9 10V5a1 1 0 1 1 2 0v4.59z"
          fill="#4A5568"
        />
      </g>
    </svg>
  )
  /* eslint-enable */
}

export default Clock
